window.rowStyleFormatter = function(row) {
    if (parseInt(row.highlight, 10) === 1) {
        return {
            classes: 'trade-negative-pnl-row'
        };
    } else {
        return {};
    }
};
